<template>
  <div>
    <view-table
        ref="viewTable"
        :limits="limits"
        :columns-property="columnsProperty"
        :filter="filter"
        module="basic"
        url="invoiceApplications"
        @reset="resetHandle"
        @delete="deleteHandle">
      <slot slot="actionBtn" slot-scope="scope">
        <el-button
            v-if="scope.row.status === 0 && limits.addAuth"
            type="primary"
            @click="editHandle(scope.row)"
        >
          编辑
        </el-button>
        <el-button
            v-if="limits.submitAuth && scope.row.status === 0"
            type="primary"
            @click="submitToAudit(scope.row)">
          提交
        </el-button>
        <el-button
            v-if="limits.financeAuditAuth && scope.row.status === 10"
            type="primary"
            @click="approve(scope.row)">
          审批
        </el-button>
        <el-button
            v-if="limits.rejectAuth && (limits.financeAuditAuth || limits.addAuth) && scope.row.status === 10"
            type="danger"
            @click="reject(scope.row)">
          驳回
        </el-button>
        <el-button
            v-if="limits.rejectAuth && limits.sharedAuditAuth && scope.row.status === 15"
            type="danger"
            @click="reject(scope.row)">
          驳回
        </el-button>
        <el-button v-if="limits.invoiceAuth && scope.row.status === 15" :loading="createInvoiceLoading" type="primary" @click="submit(scope.row)">
          开票
        </el-button>
        <el-button v-if="limits.addAuth && scope.row.status === 30 && scope.row.invoiceStatus === '1' && scope.row.cancelSign === false" type="danger" @click="getCancel(scope.row)">
          冲销
        </el-button>
      </slot>
      <template slot="otherBtn">
        <el-upload
            action=""
            :http-request="importFile"
            :show-file-list="false"
            style="float: left; margin-right: 4px;">
          <el-button type="primary" :loading="importLoading">导入模板</el-button>
        </el-upload>
        <el-button
            type="primary"
            plain
            icon="el-icon-download"
            @click="downloadModel">
          模板下载
        </el-button>
      </template>
      <template slot="adSearch">
        <div class="vm-search">
          <el-form :inline="true" :model="filter" label-width="90px" @keyup.enter.native="loadData(1)">
            <el-form-item label="状态">
              <el-select v-model="filter.status" clearable placeholder="请选择状态">
                <el-option label="全部" value=""/>
                <el-option label="草稿" value="0"/>
                <el-option label="财务审核" value="10"/>
                <el-option label="共享审核" value="15"/>
                <el-option label="已开票" value="30"/>
                <el-option label="已冲销" value="40"/>
              </el-select>
            </el-form-item>
            <el-form-item label="开票申请编号">
              <el-input v-model="filter.invoiceApplicationNo" placeholder="请输入开票申请编号" clearable/>
            </el-form-item>
            <el-form-item label="客户名称">
              <el-input v-model="filter.customerName" placeholder="请输入客户名称" clearable/>
            </el-form-item>
            <el-form-item label="客户编号">
              <el-input v-model="filter.customerNo" placeholder="请输入客户编号" clearable/>
            </el-form-item>
            <el-form-item label="客户税号">
              <el-input v-model="filter.invoiceVATNO" placeholder="请输入客户税号" clearable/>
            </el-form-item>
            <el-form-item label="标识">
              <el-select v-model="filter.sign" clearable placeholder="请选择标识">
                <el-option label="全部" value=""/>
                <el-option label="财务" value="财务"/>
                <el-option label="销售" value="销售"/>
              </el-select>
            </el-form-item>
            <el-form-item label="财务凭证号">
              <el-input v-model="filter.financialVouchers" placeholder="请输入财务凭证号" clearable/>
            </el-form-item>
            <el-form-item label="SAP发票号">
              <el-input v-model="filter.sapInvoiceNo" placeholder="请输入SAP发票号" clearable/>
            </el-form-item>
            <el-form-item label="发货单号">
              <el-input v-model="filter.deliveryBillNo" placeholder="请输入发货单号" clearable/>
            </el-form-item>
            <el-form-item label="销单编号">
              <el-input v-model="filter.salesOrderNo" placeholder="请输入订单编号" clearable/>
            </el-form-item>
            <el-form-item label="创建时间">
              <el-date-picker
                  v-model="createTimeRange"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                  value-format="yyyy-MM-dd"
                  @change="dateRangeChange('createTimeRange', 'createTimeBegin', 'createTimeEnd')"/>
            </el-form-item>
            <el-form-item label="提交时间">
              <el-date-picker
                  v-model="submitTimeRange"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                  value-format="yyyy-MM-dd"
                  @change="dateRangeChange('submitTimeRange', 'submitTimeBegin', 'submitTimeEnd')"/>
            </el-form-item>
            <el-form-item label="通过时间">
              <el-date-picker
                  v-model="passTimeRange"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                  value-format="yyyy-MM-dd"
                  @change="dateRangeChange('passTimeRange', 'passTimeBegin', 'passTimeEnd')"/>
            </el-form-item>
            <el-form-item label="申请人">
              <el-input v-model="filter.creatorName" placeholder="请输入申请人" clearable/>
            </el-form-item>
          </el-form>
        </div>
      </template>
    </view-table>
  </div>
</template>

<script>
  import ViewTable from "@/components/ViewTable";
  import loginUtil from "@/util/loginUtil";

  export default {
    name: "InvoiceListApplicationList",
    components: {ViewTable},
    data() {
      return {
        selection: [],
        limits: {
          addAuth: this.$auth(296),
          delAuth: this.$auth(321),
          downLoadAuth: this.$auth(369),
          submitAuth: this.$auth(139),
          financeAuditAuth: this.$auth(140),
          sharedAuditAuth: this.$auth(141),
          invoiceAuth: this.$auth(291),
          chongqiaoAuth: this.$auth(320),
          rejectAuth: this.$auth(51),
        },
        createInvoiceLoading:false,
        passAuth: this.$auth(435),
        createTime: "",
        submitTime: "",
        passTime: "",
        createTimeRange: [],
        submitTimeRange: [],
        passTimeRange: [],
        importLoading:false,
        filter: {
          factoryNo: "",
          status: "",
          invoiceApplicationNo: "",
          customerName: "",
          customerNo: "",
          invoiceVATNO: "",
          sign: "",
          financialVouchers: "",
          sapInvoiceNo: "",
          deliveryBillNo: "",
          createTimeBegin: "",
          createTimeEnd: "",
          submitTimeBegin: "",
          submitTimeEnd: "",
          passTimeBegin: "",
          passTimeEnd: "",
        },
        columnsProperty: [
          {
            key: "invoiceApplicationNo",
            width: 180,
            align: "center",
            render: (h, params) => {
              return h(
                "span",
                {
                  style: {
                    color: "#2d8cf0",
                    cursor: "pointer",
                  },
                  on: {
                    click: () => {
                      this.$router.push({
                        path: "/InvoiceApplicationPreview",
                        query: {
                          billId: params.row.pkId,
                          $tabName: params.row.invoiceApplicationNo,
                          selection: [],
                        },
                      });
                    },
                  },
                },
                params.row.invoiceApplicationNo,
              );
            },
          },
          {
            key: "customerName",
            width: 200,
            align: "center",
          },
          {
            key: "createTime",
            width: 180,
            align: "center",
          },
          {
            key: "submitTime",
            width: 180,
            align: "center",
          },
          {
            key: "passTime",
            width: 180,
            align: "center",
          },
          {
            key: "statusName",
            width: 100,
            align: "center",
          },
          {
            key: "creatorName",
            align: "center",
            width: 160,
          },
          {
            key: "invoiceTotalAmount",
            align: "center",
            width: 160,
          },
          {
            key: "customerNo",
            align: "center",
            width: 160,
          },
          {
            key: "invoiceVATNO",
            align: "center",
            width: 160,
          },
          {
            key: "sign",
            align: "center",
            width: 160,
          },
          {
            key: "financialVouchers",
            align: "center",
            width: 160,
          },
          {
            key: "sapInvoiceNo",
            align: "center",
            width: 160,
            ellipsis: true,
            tooltip: true,
          },
          {
            key: "note",
            align: "center",
            width: 160,
            ellipsis: true,
            tooltip: true,
          },
          {
            key: "invoiceStatus",
            align: "center",
            width: 160,
          },
          {
            key: "passTime",
            align: "center",
            width: 160,
          },
          {
            key: "action",
            width: 200,
            slot: "action",
            fixed: "right",
          },
        ],
      };
    },
    watch: {
      "filter.createTimeBegin": {
        handler(newVal) {
          if (newVal) {
            this.createTimeRange = [];
            this.createTimeRange.push(this.filter.createTimeBegin);
            this.createTimeRange.push(this.filter.createTimeEnd);
          }
        },
      },
    },
    methods: {
      loadData(pageNum) {
        this.$refs.viewTable.loadData(pageNum);
      },
      goto(row) {
        this.$router.push({
          path: "/InvoiceApplicationPreview",
          query: {
            billId: row.pkid,
            $tabName: row.invoiceApplicationNo,
          },
        });
      },
      otherAuth(row) {
        // 仅草稿可以删除
        return row.status !== 0;
      },
      resetHandle(filter) {
        this.filter = Object.assign(this.filter, filter);
      },
      deleteHandle(row) {
        this.$confirm("是否确认要进行删除？", "提示", {
          confirmButtonText: "是",
          cancelButtonText: "否",
          type: "warning",
        }).then(() => {
          this.$http.delete("basic", "invoiceApplications", row.pkId).then((resp) => {
            if (resp.success) {
              this.loadData();
              this.$message.success("删除成功");
            }
          });
        });
      },
      submitToAudit(row) {
        this.$confirm("是否确认提交？", "提示", {
          confirmButtonText: "是",
          cancelButtonText: "否",
          type: "warning",
        }).then(() => {
          this.$http.get("basic", `invoiceApplications/submit/${row.pkId}`)
            .then((resp) => {
              if (resp.success) {
                this.$message.success("提交成功");
                this.loadData(1);
              }
            });
        }).catch(() => {});
      },
      editHandle(row) {
        this.$router.push({
          path: "/InvoiceApplicationEdit",
          query: {
            billId: row.pkId,
            $tabName: row.invoiceApplicationNo,
          },
        });
      },
      dateRangeChange(timeRange, timeStart, timeEnd) {
        if (this[timeRange]) {
          this.filter[timeStart] = this[timeRange][0];
          this.filter[timeEnd] = this[timeRange][1];
        } else {
          this.filter[timeStart] = "";
          this.filter[timeEnd] = "";
        }
      },

      createTimeChange(date) {
        if (date !== null) {
          this.filter.createTimeBegin = date[0];
          this.filter.createTimeEnd = date[1];
        } else {
          this.filter.createTimeBegin = "";
          this.filter.createTimeEnd = "";
        }
      },

      submit(row) {
        this.$confirm("是否确认要进行操作？", "提示", {
          confirmButtonText: "是",
          cancelButtonText: "否",
          type: "warning",
        }).then(() => {
          this.createInvoiceLoading=true;
          this.$http.get("basic", `invoiceApplications/createSapInvoice/${row.pkId}`)
            .then(resp => {
              if (resp.success) {
                this.loadData();
                this.createInvoiceLoading=false;
              }
            });
        }).catch(() => {
          // 用户取消，不执行操作
        });
      },
      cancelSapInvoice(row) {
        this.$confirm("是否确认要进行开票？", "提示", {
          confirmButtonText: "是",
          cancelButtonText: "否",
          type: "warning",
        }).then(() => {
          this.$http.get("basic", `invoiceApplications/cancelSapInvoice/${row.pkId}`)
            .then(resp => {
              if (resp.success) {
                this.loadData();
              }
            });
        }).catch(() => {
          // 用户取消，不执行操作
        });

      },

      submitTimeChange(date) {
        if (date !== null) {
          this.filter.submitTimeBegin = date[0];
          this.filter.submitTimeEnd = date[1];
        } else {
          this.filter.submitTimeBegin = "";
          this.filter.submitTimeEnd = "";
        }
      },

      passTimeChange(date) {
        if (date !== null) {
          this.filter.passTimeBegin = date[0];
          this.filter.passTimeEnd = date[1];
        } else {
          this.filter.passTimeBegin = "";
          this.filter.passTimeEnd = "";
        }
      },

      getCancel(row) {
        this.$router.push({
          path: "/InvoiceApplicationPreview",
          query: {
            billId: 0,
            $tabName: "开票申请",
            selection: [],
            cancelId:row.pkId,
          },
        });
      },

      // 审批通过
      approve(row) {
        const statusText = row.status === 10 ? "财务审核" : "共享审核";
        const nextText = row.status === 10 ? "共享审核" : "已开票";
        this.$confirm(`是否确认将【${statusText}】审批通过到【${nextText}】？`, "提示", {
          confirmButtonText: "是",
          cancelButtonText: "否",
          type: "warning",
        }).then(() => {
          this.$http.get("basic", `invoiceApplications/approve/${row.pkId}`)
            .then((resp) => {
              if (resp.success) {
                this.$message.success("审批通过");
                this.loadData(1);
              }
            });
        }).catch(() => {});
      },

      // 驳回
      reject(row) {
        const statusText = row.status === 10 ? "财务审核" : "共享审核";
        const prevText = row.status === 10 ? "草稿" : "财务审核";
        // 共享审核(15)时允许选择驳回到草稿(0)或财务审核(10)
        if (row.status === 15) {
          this.$prompt(`将【${statusText}】驳回，请输入驳回原因`, "驳回", {
            confirmButtonText: "选择驳回目标",
            cancelButtonText: "取消",
            inputType: "textarea",
          }).then(({ value }) => {
            this.$msgbox({
              title: "选择驳回目标",
              message: "<div style='line-height: 2;'>将【共享审核】驳回到：</div><div style='color: #E6A23C; margin-top: 10px;'>▶ 点击【草稿】按钮 → 驳回到【草稿】</div><div style='color: #409EFF;'>▶ 点击【财务审核】按钮 → 驳回到【财务审核】</div>",
              showCancelButton: true,
              confirmButtonText: "财务审核",
              cancelButtonText: "草稿",
              dangerouslyUseHTMLString: true,
              distinguishCancelAndClose: true,
              type: "warning",
            }).then(() => {
              // 确认按钮：驳回到财务审核(10)
              this.$http.post("basic", `invoiceApplications/reject/${row.pkId}`, { rejectReason: value || "" })
                .then((resp) => {
                  if (resp.success) { this.$message.success("驳回成功"); this.loadData(1); }
                });
            }).catch((action) => {
              if (action === "cancel") {
                // 取消按钮：驳回到草稿(0)
                this.$http.post("basic", `invoiceApplications/rejectToDraft/${row.pkId}`, { rejectReason: value || "" })
                  .then((resp) => {
                    if (resp.success) { this.$message.success("驳回成功"); this.loadData(1); }
                  });
              }
            });
          }).catch(() => {});
        } else {
          this.$prompt(`将【${statusText}】驳回到【${prevText}】，请输入驳回原因`, "驳回", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            inputType: "textarea",
          }).then(({ value }) => {
            this.$http.post("basic", `invoiceApplications/reject/${row.pkId}`, { rejectReason: value || "" })
              .then((resp) => {
                if (resp.success) { this.$message.success("驳回成功"); this.loadData(1); }
              });
          }).catch(() => {});
        }
      },

      //导入
      importFile(params) {
        this.importLoading = true;
        let formData = new FormData();
        formData.append("file", params.file);
        formData.append("Authorization", loginUtil.getToken());
        this.$http.post("basic", "invoiceApplications/createApplicationByFile", formData).then((res) => {
          if (res.success) {
            this.$router.push({
              path: "/InvoiceApplicationPreview",
              query: {
                billId: 0,
                $tabName: "开票申请",
                invoiceApplication: res.data,
              },
            });
          } else {
            this.$message.error("导入失败");
          }
        }).catch(() => {
          this.$message.error("导入失败");
        }).finally(() => {
          this.importLoading = false;
        });
      },

      //下载导入模板
      downloadModel() {
        window.open("/file/工控开票导入模板.xlsx");
      },
    },
  };
</script>
